const getFlattenedResultsArray = (continents) => {
    const flattenedCities = [];
    continents.forEach((results) => {
        results.forEach((result) => {
            if (result.id) {
                flattenedCities.push(result);
            }
        });
    });

    return flattenedCities;
};

export { getFlattenedResultsArray };
